import { render, staticRenderFns } from "./DetailsInner.vue?vue&type=template&id=d6de79ce&scoped=true&"
import script from "./DetailsInner.vue?vue&type=script&lang=js&"
export * from "./DetailsInner.vue?vue&type=script&lang=js&"
import style0 from "./DetailsInner.vue?vue&type=style&index=0&id=d6de79ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6de79ce",
  null
  
)

export default component.exports